(function(){

	document.addEventListener('mousedown', function(e) {
		let $partial = e.target.closest('[partial]');
		if ($partial) {
			$partial.dataset.downTime = Date.now();
		}
	});

	document.addEventListener('mouseup', function(e) {
		let $partial = e.target.closest('[partial]');

		if ($partial) {
			let downTime = $partial.dataset.downTime || 0;
			let upTime = Date.now();

			// Click duration should be short to count as a click
			if ((upTime - downTime) < 200) {
				let $link = $partial.querySelector('[partial-link]');

				if ($link && e.target.closest('a') !== $link) {
					if (e.metaKey || e.ctrlKey) {
						window.open($link.href, '_blank');
					} else if (e.shiftKey) {
						window.open($link.href);
					} else if (e.button === 0) {
						$link.click();
					} else if (e.button === 1) { // Middle click
						let oldTarget = $link.getAttribute('target');
						$link.setAttribute('target', '_blank');
						$link.click();
						$link.setAttribute('target', oldTarget);
					}
				}
			}
		}
	});

})();